import React from 'react';
import {
  getRFC3339,
} from 'mn-utils/formatTime';
import upperFirst from 'mn-utils/upperFirst';
import trim from 'mn-utils/trim';
import changeProviderProvider from 'mn-utils/changeProviderProvider';
import RefreshIcon from '@material-ui/icons/Refresh';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import {
  apiAdminStableCoinWithdrawList,
  apiAdminStableCoinWithdrawUpdate
} from '../../../../api/admin/stablecoinsWithdraws';
import {
  openV1PopupInfo,
  openPopupWindow,
} from '../../../../emitters/popup';
import formatTime from '../../../../utils/formatTime';
import ButtonD from '../../../dumb/Button/D';
import ButtonUp from '../../../dumb/Button/Up';
import CaptionA from '../../../dumb/Caption/A';
import ColA from '../../../dumb/Col/A';
import ColB from '../../../dumb/Col/B';
const ColB2 = require("../../../dumb/Col/B2");
import HeaderA from '../../../dumb/Header/A';
import LayoutA from '../../../dumb/Layout/A';
import RowA from '../../../dumb/Row/A';
import RowB from '../../../dumb/Row/B';
import TextField from '../../../dumb/TextField/H';
import Popup from '../../../dumb/Popup/C';
import WrapperWithLoading from '../../../dumb/WrapperWithLoading';
import virtualOutputComponentProvider from '../../../../utils/virtualOutputComponentProvider';
import isSafeNumber from '../../../../utils/isSafeNumber';

const {
  DisplayIdAdmin,
  DisplayAddressAdmin,
  DisplayDataAdmin,
  DisplayAmountAdmin,
  DisplayHashAdmin,
  DisplayDateTimeAdmin
} = require("../../../dumb/DisplayData");

const STATUS_MAP = {
  ready_for_withdraw: 'Ready for withdraw',
  requested_by_merchant: 'Requested by merchant',
  approved_by_buyer: 'Approved by buyer',
  refund_done: 'Refund done',
  failed: 'Failed',
  cancelled: 'Cancelled',
};

module.exports = virtualOutputComponentProvider({
  rowHeight: 70,
  nodata: (<div className="f16 fw4 cF mt20 ttU tc w">No data</div>),
  request: apiAdminStableCoinWithdrawList,
  getParams: (self) => {
    const state = self.state || {};
    return {
      from: Math.floor(state.dateFrom.getTime() * 0.001),
      to: Math.floor(state.dateTo.getTime() * 0.001),
    };
  },
  wrapper(render, setState, self) {
    const {
      handleSortProvider,
      update,
    } = self;

    const handleSortByOrderIdToggle = handleSortProvider('order_id');
    const handleSortByStatusToggle = handleSortProvider('status');

    const dateTo = new Date();
    const dateFrom = new Date();
    dateFrom.setDate(dateTo.getDate() - 30);
    self.state = {
      ...(self.state || {}),
      dateTo,
      dateFrom,
    };

    function Item({
      data,
    }) {
      const id = data.id || '';
      const orderId = data.order_id || '';
      const transactionId = data.tx_id || '';

      const scAmount = data.amount || '';
      const scCode = data.sc_code || '';
      const scNetwork = data.sc_network || '';
      // const amount = `${scAmount} ${scCode}`;

      const assetAmount = data.asset_amount || '';
      const assetCode = data.asset_code || '';
      // const asset = `${assetAmount} ${assetCode}`;

      const status = data.life_flow || '';
      const hash = data.tx_hash || '';
      const createdAt = data.created_at || '';
      const address = data.to_address || null;
      const addressTag = data.to_address_tag || null;
      // const exchange = data.exchange_type || '';
      // const merchantId = data.merchant_id || '';
      const merchantName = data.merchant_name || '';
      const merchantEmail = data.merchant_email || '';

      return (
        <div className="dB w olN tdN cF dn bgF1:h">
          <RowA className="f12">
            <ColA className="wmin180 fx1">
              <DisplayIdAdmin>
                {id}
              </DisplayIdAdmin>
            </ColA>
            <ColA className="wmin200 fx1">
              <DisplayDataAdmin>{merchantName || merchantEmail}</DisplayDataAdmin>
            </ColA>
          {/*  <ColA className="w(|min)150 pl15">*/}
          {/*    <Tooltip>{orderId}</Tooltip>*/}
          {/*  </ColA>*/}
            <ColA className="wmin150 fx1">
              <DisplayAddressAdmin>
                {address}
              </DisplayAddressAdmin>
              {address && addressTag ? (
                <DisplayDataAdmin className="dB cCC mt5">
                  tag: {addressTag}
                </DisplayDataAdmin>
              ) : null}
            </ColA>
            <ColA className="wmin180 fx1">
              <DisplayHashAdmin symbol={scCode} hash={hash} />
            </ColA>
            <ColA className="wmin130 fx1">
              <DisplayAmountAdmin
                amount={scAmount}
                symbol={scCode}
                type="coin"
              />
            </ColA>
            <ColA className="wmin130 fx1">
              <DisplayDataAdmin>{scNetwork}</DisplayDataAdmin>
            </ColA>
            <ColA
              className={`wmin140 fx1 tl c59CACA.initiated c9259CA.ready_for_withdraw
              c59CACA.requested_by_merchant cCAC359.approved_by_buyer
              c82CA59.completed cCA5959.failed cCA5959.cancelled ${status}`}
            >
              {upperFirst(status)}
            </ColA>
            <ColA className="w125">
              <DisplayDateTimeAdmin date={createdAt} />
            </ColA>
            <ColA className="w70">
              <IconButton
                className="olN-i"
                onClick={() => {
                  openPopupWindow((setPopupState, popup) => {
                    const {
                      close,
                    } = popup;
                    popup.state = {
                      transactionId,
                      assetAmount,
                      clicked: false,
                    };

                    const changeProvider = changeProviderProvider(setPopupState);
                    const handleChangeTransactionId = changeProvider('transactionId');
                    const handleChangeAssetAmount = changeProvider('assetAmount');

                    return (stateOfPopup) => {
                      const {
                        transactionId,
                        assetAmount,
                      } = stateOfPopup;
                      const _transactionId = trim(transactionId);
                      const _assetAmount = trim(assetAmount);
                      let assetAmountHelperText = 'Asset amount is not valid';
                      const amountHigherThenMax = Number(assetAmount) > Number(scAmount);
                      const invalidAssetAmount = !isSafeNumber(_assetAmount);
                      if (!_assetAmount) {
                        assetAmountHelperText = 'Obligatory field';
                      } else if (amountHigherThenMax) {
                        assetAmountHelperText = 'Amount is higher then refund summ';
                      }

                      return (
                        <Popup
                          caption={(
                            <div className="layoutRow fhaS fvaC w">
                              <div>Edit withdrawal</div>
                              <div className="mh30 fw3 rlv st-2">|</div>
                              <div className="f12 fx1 wmin0 tov ov wsNW">{id}</div>
                            </div>
                          )}
                          onCancel={close}
                          disabled={stateOfPopup.clicked && invalidAssetAmount}
                          onSave={() => {
                            if (invalidAssetAmount || amountHigherThenMax) {
                              setPopupState({
                                clicked: true,
                              });
                              return;
                            }

                            setPopupState({
                              loading: true,
                            });

                            apiAdminStableCoinWithdrawUpdate({
                              id,
                              tx_id: _transactionId,
                              asset_amount: _assetAmount,
                            }).finally((error) => {
                              setPopupState({
                                loading: false,
                              });
                              if (error) {
                                return;
                              }
                              update();
                              close();
                            }).then(() => {
                              openV1PopupInfo(['Refund has been changed']);
                            });
                          }}
                        >
                          <WrapperWithLoading
                            loading={stateOfPopup.loading}
                          >
                            <TextField
                              className="mt20 wmax472"
                              label="Transaction ID"
                              value={transactionId}
                              onChange={handleChangeTransactionId}
                              maxLength={250}
                            />
                            <TextField
                              className="mt20 wmax472"
                              label="Asset amount"
                              value={assetAmount}
                              onChange={handleChangeAssetAmount}
                              error={stateOfPopup.clicked && (invalidAssetAmount || amountHigherThenMax)}
                              helperText={assetAmountHelperText}
                              maxLength={250}
                            />
                          </WrapperWithLoading>
                        </Popup>
                      );
                    };
                  });
                }}
              >
                <div className="sq23 layoutRow fhaC fvaC cF">
                  <EditIcon/>
                </div>
              </IconButton>
            </ColA>
          </RowA>
        </div>
      );
    }

    return (state, props) => {
      const params = state.params || {};
      const sort = params.sort;
      const loading = state.loading || false;
      const showUp = state.showUp || false;


      return (
        <LayoutA>
          <HeaderA>
            <CaptionA>Stablecoin withdrawals</CaptionA>
            <div className="layoutRow fhaS fvaC">
              <WrapperWithLoading
                loading={loading}
              >
                <ButtonD
                  className="wmin100"
                  onClick={self.update}
                >
                  <RefreshIcon/>
                  <div className="pl15">Refresh</div>
                </ButtonD>
              </WrapperWithLoading>
            </div>
          </HeaderA>

          <div className="abs st70 sh-45 sb10 ov">
            <div className="ovxA abs s ph45 pb80">
              <div className="wmin1280 rlv h">
                <div>
                  <RowB className="f14">
                    <ColB className="wmin180 fx1">
                      ID
                    </ColB>
                    <ColB className="wmin200 fx1">
                      Merchant name
                    </ColB>
                    {/*<TableHeadCell*/}
                    {/*  className="w(|min)150"*/}
                    {/*  caption="Order ID"*/}
                    {/*  propName="order_id"*/}
                    {/*  sort={sort}*/}
                    {/*  onClick={handleSortByOrderIdToggle}*/}
                    {/*/>*/}
                    <ColB className="wmin150 fx1">
                      Address<br />to withdraw
                    </ColB>
                    <ColB className="wmin180 fx1">
                      Trx Hash
                    </ColB>
                    <ColB className="wmin130 fx1">
                      Amount
                    </ColB>
                    {/*<ColB className="wmin130 fx1">*/}
                    {/*  Stablecoin*/}
                    {/*</ColB>*/}
                    <ColB className="wmin130 fx1">
                      Network
                    </ColB>
                    <ColB className="wmin140 fx1">
                      Status
                    </ColB>
                    {/*<TableHeadCell*/}
                    {/*  className="wmin140 fx1"*/}
                    {/*  caption="Status"*/}
                    {/*  propName="status"*/}
                    {/*  sort={sort}*/}
                    {/*  onClick={handleSortByStatusToggle}*/}
                    {/*/>*/}
                    <ColB className="w125">
                      Created
                    </ColB>
                    <ColB2 className="w70"/>
                  </RowB>
                </div>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(Item)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={showUp}
              onClick={self.handleToUp}
            />
          </div>
        </LayoutA>
      );
    };
  },
});
